var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table-container" }, [
    _c("div", { staticClass: "header-area" }, [
      _c("h2", { staticClass: "subtitle" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.$t("analytics.your_watchlist")) + "\n    "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-area" },
      [
        _c("TopPairs", {
          attrs: { "with-search": true, "watchlist-enabled": true },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "header-area second-header" }, [
      _c("h1", [
        _vm._v(
          "\n      " + _vm._s(_vm.$t("analytics.pairs_header")) + "\n    "
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-area" },
      [_c("TopPairs", { attrs: { "with-search": true } })],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }